import { Component, HostListener, Input, OnInit, OnDestroy, ViewEncapsulation, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { OrgsIndividualComponent } from "./../orgs-individual/orgs-individual.component";
import { TeamReportServiceService } from "../team-report/team-report-service.service";
import { HttpService } from "./../../http.service";
import { Store } from "@ngrx/store";
import { CommonDataService } from "../common-data.service";
import acme_roster_data from "../orgs/acme_roster.json";
import { LambdaFunctionService } from "../../service/lambda-function.service";
import { RosterServiceService } from "./roster-service.service";
import { TeamManagementService } from "./team-management.service";
import { RosterMemberService } from "./roster-member.service";
import { RosterMemberOpsService, IRosterOpsHost } from "./roster-member-ops.service";
import { RosterTeamOpsService, IRosterTeamOpsHost } from "./roster-team-ops.service";
import { RosterSearchService, IRosterSearchHost } from "./roster-search.service";
import { RosterSelectionService, IRosterSelectionHost } from "./roster-selection.service";
import { RosterNavService, IRosterNavHost } from "./roster-nav.service";
import { RosterModalService } from "./roster-modal.service";
import roster_members from './../orgs/acme_roster_members_name.json'

@Component({
  selector: "app-org-individual-teams",
  templateUrl: "./org-individual-teams.component.html",
  styleUrls: ["./org-individual-teams.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [RosterModalService],
})
export class OrgIndividualTeamsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private teamOpsService = inject(RosterTeamOpsService);
  private searchSvc = inject(RosterSearchService);
  private selectionSvc = inject(RosterSelectionService);
  private navSvc = inject(RosterNavService);
  public modalSvc = inject(RosterModalService);

  // ── Core identifiers ──
  id: any;
  org_name: string;
  env;
  ngrxAccount: any;
  loggedInUserEamil;
  loginMemTeams;
  @Input() rosterName;
  @Input() totalMembers;

  // ── Team data ──
  teams: any;
  teamsData;
  teamsMeta: any;
  currentTeam: any;
  team_name: any;
  team_members: any;
  team_id: any;
  teamName: any;
  teamID: any;
  teamMembers: any = [];
  unassignedTeam: any;
  allTeamIdsTtl: Array<object> = [];
  defaultShowingMembers = 5;
  hirarchicalgridData = [];
  sessions: any; // accessed by orgteam-members via injector
  memViewTeam;
  globalGroup: any; // accessed by orgteam-members via injector

  // ── Roster / member data ──
  roasterData;
  roasterDataCounter: number = 0;
  roasterdefaultCounter = 20;
  selectedRosterMembers: any = [];
  selectedFilterMbr = [];
  rosterMemberCheckedCounter = 0;
  newUseremail;

  // ── Sorting ──
  sortType: string = "desc";
  queryType: string = "first_name_order";
  teamQueryType: string = "created_at_order";
  rosterSortType = "asc";
  sortEmailIcon = "asc";
  sortLastNameIcon = "asc";

  // ── Search / filter ──
  filterData: any = "";
  filterInput: boolean = true;
  filterByTeam: string = "tested";
  filterRoster;
  rosterSearch = false;
  clear: boolean = false;
  searchby: string = "search";
  teamSrchName: string;
  teamSrchBy: string = "name";

  // ── Pagination ──
  currentPg = 1;
  teamMemberCurrentPg = 1;
  memberCurrentPg = 1;
  acmeTeamMemberCurrentPg = 1;
  acmeProfileCounter = 1;
  teamsPerPage = 20;
  memOnPg: number = 5;

  // ── View state ──
  gridHirView = "grid";
  collapse_expand_All: boolean = false;
  loading: any;
  loadingTeams: boolean = true;
  teamLoaders: { [key: string]: boolean } = {};
  selectAll = false;

  // ── Graph / report ──
  selectedGroupProfileTeamsArr: any = [];
  slectedIndividualTeamArr: any = [];
  mockupReportArgs;
  mockupReportArgsArr: any[] = [];

  // ── ACME demo roster ──
  acme_roster = acme_roster_data;
  demo_roster_id: string = this.acme_roster.id;
  acme_roster_members = roster_members;
  isLocalstorage = false;


  constructor(
    public activatedRoute: ActivatedRoute,
    public orgs: OrgsIndividualComponent,
    public http: HttpClient,
    public modalService: NgbModal,
    public route: Router,
    public teamReportService: TeamReportServiceService,
    private httpService: HttpService,
    public store: Store<any>,
    public CommonDataService: CommonDataService,
    public lmbda_service: LambdaFunctionService,
    public rosterService: RosterServiceService,
    public teamManagementService: TeamManagementService,
    public rosterMemberService: RosterMemberService,
    public memberOpsService: RosterMemberOpsService
  ) {}


  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected compareByName(a, b) {
    const aName = a?.name?.toLowerCase() || '';
    const bName = b?.name?.toLowerCase() || '';
    if (aName < bName) return -1;
    if (aName > bName) return 1;
    return 0;
  }

  private getMemberEmail(mbr: any): string {
    return mbr?.default_identity?.email || mbr?.default_profile?.email || '';
  }

  protected rebuildAllTeamIdsTtl() {
    this.allTeamIdsTtl = [];
    this.teams.forEach((team) => {
      this.allTeamIdsTtl.push({
        teamId: team.id,
        showMember: this.defaultShowingMembers,
        teamName: team.name,
        memberships_count: team.memberships_count,
      });
    });
  }

  async ngOnInit() {
    this.env = environment;
    this.id = this.orgs.id;
    this.modalSvc.teamWizard = false;
    this.loading = true;
    this.totalMembers = localStorage.getItem("orgTotalMember");
    this.rosterName = localStorage.getItem("currentOrgName");
    this.loggedInUserEamil = localStorage.getItem("email");
    this.ngrxAccount = this.store.select<any>((state) => state.profile.account);
    this.ngrxAccount.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
      this.loginMemTeams = res["member"]?.teams_names;
    });

    this.teamReportService.team_members.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.length > 0) {
        this.teamMembers = res;
      }
    });
    // getting teams api
    await this.getTeamsData();
    this.org_name = this.route.url;
    this.org_name = this.org_name.replace("/teams", "");
    this.org_name = this.org_name.replace("/orgs/", "");
    this.roasterMembers();
    this.getAllInvitation();
  }

  public comingFromGlobalSearch() {
    localStorage.setItem('fs-roster-gs', JSON.stringify(false))
    this.route.navigate(['/orgs'])
  }

  // making hierarchical data
  hirerachicalData() {
    this.selectedGroupProfileTeamsArr = [];
    this.slectedIndividualTeamArr = [];
    this.mockupReportArgsArr = [];
    this.gridHirView = 'hierar';
    localStorage.setItem('rosterDetailView', 'hierar');
    this.hirarchicalgridData = this.teamManagementService.buildHierarchicalData(this.teams);
  }

  gridView(value = "grid") {
    this.gridHirView = value;
    localStorage.setItem("rosterDetailView", value);
    this.teamSrchName = "";
    this.selectedGroupProfileTeamsArr = [];
    this.slectedIndividualTeamArr = [];
    this.mockupReportArgsArr = [];
  }

  public getTeamsData() {
    this.teamManagementService.loadTeams(
      this.id,
      { queryType: this.teamQueryType, sortType: this.sortType, perPage: this.teamsPerPage, page: this.teamMemberCurrentPg },
      this.defaultShowingMembers
    ).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.teams = result.teams;
        this.teamsMeta = result.teamsMeta;
        this.allTeamIdsTtl = result.allTeamIdsTtl;
        this.unassignedTeam = result.unassignedTeam;
        this.team_members = result.team_members;
        this.team_name = result.team_name;
        this.team_id = result.team_id;
        this.currentTeam = 0;
        this.loadingTeams = false;
        this.teamReportService.team_members.next(result.teamMemberArr);
        localStorage.getItem('rosterDetailView') === 'hierar'
          ? this.hirerachicalData()
          : localStorage.getItem('rosterDetailView') === 'dirView'
          ? this.gridView('dirView')
          : this.gridView();
      },
      error => {
        if (error.status === 404 && localStorage.getItem('fs-roster-gs') === 'true') {
          this.comingFromGlobalSearch();
        }
        this.showError(error);
      }
    );
  }

  public searchMembers(e) {
    if (this.searchby == "search") {
      this.searchby = "first_name";
    }

    let sortData: any;

    if (this.teamSrchName.length >= 3 || this.teamSrchName.length == 0) {
      sortData = this.CommonDataService.sortData(
        `${environment.profileURL}/api/v1/teams/` +
          this.memViewTeam?.id +
          `/memberships.json?`,
        this.searchby,
        this.teamSrchName
      );
      sortData.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.memViewTeam.memberships = res?.memberships;
        this.loading = false;
      });
    }
  }

  public async acmeSearchTeam(searchTerm): Promise<any[]> { return []; }

  public searchTeam(e) {
    if (e.which == 8 && this.teamSrchName?.length == 0) {
      this.getTeamsData();
    }
    if (this.teamSrchName.length > 2) {
      this.loading = true;
      this.teamManagementService.searchTeams(this.id, {
        queryType: this.queryType,
        sortType: this.sortType,
        teamSrchBy: this.teamSrchBy,
        teamSrchName: this.teamSrchName,
        perPage: this.teamsPerPage,
        page: this.currentPg,
      }).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.teams = data;
        if (this.gridHirView === 'hierar') { this.hirerachicalData(); }
        this.loading = false;
      });
    }
  }

  public cancelSrchTeam() {
    if (this.teamSrchName?.length > 0) {
      this.getTeamsData();
      this.CommonDataService.getPageData(
        `${environment.profileURL}/api/v1/organizations/${this?.id}/teams.json`,
        this.currentPg,
        this.teamsPerPage
      ).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.memViewTeam.memberships = res?.memberships;
      });
      this.teamSrchName = '';
    }
  }

  public cancelSrchTeamMember(id: any) {
    if (id) {
      this.rosterMemberService.fetchTeamMemberships(id, this.teamsPerPage, this.currentPg)
        .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          this.memViewTeam.memberships = res?.memberships;
        });
      this.teamSrchName = '';
    }
  }

  public add_acme_memmbers(index: number): any { return undefined; }

  // Get All Roster Members with pagination & Default Sort
  public roasterMembers(membersCount = 20, pageNo = 1) {
    this.currentPg = pageNo;
    this.loading = true;
    this.roasterData = this.rosterMemberService.fetchMembers(this.id, membersCount, pageNo, this.queryType, this.sortType);
    this.roasterData.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      const item = document.querySelector('.teammates__head th input[type="checkbox"]') as HTMLInputElement;
      if (item?.checked) { item.click(); }
      this.teamsData = res;
      this.loading = false;
      if (res?.meta?.total_count !== undefined) {
        this.totalMembers = res?.meta?.total_count;
        localStorage.setItem('orgTotalMember', res.meta.total_count);
      }
      if (this.selectedRosterMembers) {
        this.teamsData.members.map((item) => {
          const match = this.selectedRosterMembers.find((obj) => obj.id === item.id);
          if (match) { item['checked'] = true; }
        });
      }
    });
  }

  public sortTeamMembers(memberships) {
    return this.teamManagementService.sortTeamMembers(memberships);
  }

  public openTeam(record) {
    if (record.open) {
      record.open = false;
    } else {
      record.open = true;
    }
  }
  // Update Filter for Roster Member Search
  public updateFilter(event) {
    const val = event.target.value.toLowerCase();
    this.searchby = val;
    this.searchRoaster(this.filterRoster, true);
  }

  // open and close team popup — thin delegate required by IRosterTeamOpsHost
  public openCloseTeamPopup(open = false, teamId = "", teamName = "") {
    this.modalSvc.openCloseTeamPopup(open, teamId, teamName, this.teams);
  }

  // update team name
  public async UpdateTeam() {
    this.teamOpsService.UpdateTeam(this as unknown as IRosterTeamOpsHost);
  }

  public async add_acme_Team(teamName: string, index: number) {}

  // add new team via API
  public async addTeam() {
    this.teamOpsService.addTeam(this as unknown as IRosterTeamOpsHost);
  }

  public async delAcmeTeam(team: any) {}

  // delete team via API
  public async deleteTeam(id, index) {
    this.teamOpsService.deleteTeam(id, index, this as unknown as IRosterTeamOpsHost);
  }

  public deleteSelectedTeams(): void {
    this.teamOpsService.deleteSelectedTeams(this as unknown as IRosterTeamOpsHost);
  }

  public onDownloadTeamsCsv(format: string): void {
    this.rosterService.downloadTeamsCsv(this.slectedIndividualTeamArr, this.rosterName, format);
  }

  public showError(error) {
    this.rosterService.showError(error);
  }

  // open close add member to additional team — thin delegate (needs host ref)
  public additionalTeamPopup(memberDetail: any = null, invitepop = false) {
    this.modalSvc.additionalTeamPopup(memberDetail, invitepop, this);
  }

  // close additional team popup — thin delegate (needs host ref)
  public additionalTeamPopupClose(checkChangesPopup: boolean = true) {
    this.modalSvc.additionalTeamPopupClose(checkChangesPopup, this);
  }

  // load more
  public loadMore(teamId = "", roaster = 0, allMembers: false) {
    this.navSvc.loadMore(teamId, roaster, allMembers, this as unknown as IRosterNavHost);
  }

  // promote to lead (make team leader)
  public async mkTeamLead(member, role_id, teamData = undefined) {
    await this.teamOpsService.mkTeamLead(member, role_id, teamData, this as unknown as IRosterTeamOpsHost);
  }

  // sort roster members via API
  public sortRoaster(sType: string, qType = 'last_name_order') {
    this.searchSvc.sortRoaster(sType, qType, this as unknown as IRosterSearchHost);
  }

  public async acmeSearch(searchTerm): Promise<any[]> { return []; }

  // roaster filter function
  public async searchRoaster(value, showHide, clear = false) {
    return this.searchSvc.searchRoaster(value, showHide, clear, this as unknown as IRosterSearchHost);
  }

  // add new teammate or new roster member
  public addNewTeamMate() {
    this.memberOpsService.addNewTeamMate(this as unknown as IRosterOpsHost);
  }

  async addAcmeRosterMemberToTeam(data: any) {}

  // add roster member to team
  async addRosterMemberInTeam() {
    await this.memberOpsService.addRosterMemberInTeam(this as unknown as IRosterOpsHost);
    this.selectAll = false;
    this.selectAllRoaster(false);
    document.querySelector("body").classList.remove("oh");
  }
  // add member from inivitation
  public async addInvitationMem() {
    await this.memberOpsService.addInvitationMem(this as unknown as IRosterOpsHost);
  }
  // add member to team
  public async add_acme_member() {}

  // add members to team
  public async addTeamMembers() {
    await this.memberOpsService.addTeamMembers(this as unknown as IRosterOpsHost);
  }
  public async removedMember(member, teamId = "") {
    await this.memberOpsService.removedMember(member, teamId, this as unknown as IRosterOpsHost);
  }
  // removed acme roster member from team
  removeAcmeMember(team, member) {}

  // remove team member from team — accepts {member,team} from card OR plain member from directory
  public async removeTeamMember(event: any) {
    const member = event?.member ?? event;
    const team = event?.team;
    if (team) {
      member.team_id = team.id;
      member.team_name = team.name;
    }
    await this.teamOpsService.removeTeamMember(member, this as unknown as IRosterTeamOpsHost);
  }

  // set remove member state — thin delegate (overridden by ACME)
  public removeRosterMem(record: any = "", oneOrMulti = 0, type = "member", index = undefined) {
    this.modalSvc.removeRosterMem(record, oneOrMulti, type, index);
  }

  // add all roster members to a team
  async addAllMembers(team) {
    this.memberOpsService.addAllMembers(team, this as unknown as IRosterOpsHost);
  }

  public accord(toggleClass, e, collapseAll: boolean = false) {
    if (collapseAll) {
      let allItems = document.querySelectorAll(`.${toggleClass}`);
      if (!this.collapse_expand_All) {
        allItems.forEach((item) => {
          (item as HTMLElement).style.display = 'none';
          item.classList.remove("active");
        });
      } else {
        allItems.forEach((item) => {
          (item as HTMLElement).style.display = '';
          item.classList.add("active");
        });
      }
      this.collapse_expand_All = !this.collapse_expand_All;
    } else {
      if (e) {
        e.target.classList.toggle("active");
      }
      let items = document.querySelectorAll(`.${toggleClass}`);
      items.forEach((item) => {
        const el = item as HTMLElement;
        el.style.display = el.style.display === 'none' ? '' : 'none';
      });
    }
  }

  participantView(from, team, mbr: any = "") {
    this.navSvc.participantView(from, team, mbr, this as unknown as IRosterNavHost);
  }

  // check all roster members
  selectAllRoaster(checked) {
    this.selectionSvc.selectAllRoaster(checked, this as unknown as IRosterSelectionHost);
  }

  public async getAllInvitation() {
    if (this.filterRoster) {
      this.searchRoaster(this.filterRoster, true);
    } else {
      if (this.searchby !== "invitation") {
        this.filterData = "";
      }
    }
  }

  public async getSelInvMem() {
    if (this.modalSvc.selectedInvitation == "Select Invitation") {
      this.filterData = "";
    } else {
      this.loading = true;
      for (let i = 0; i < this.modalSvc.invitationList?.length; i++) {
        if (
          this.modalSvc.invitationList[i]?.members_count == 0 &&
          this.modalSvc.invitationList[i].id == this.modalSvc.selectedInvitation
        ) {
          this.filterData = "Member not Found";
          this.loading = false;
          break;
        } else if (this.modalSvc.invitationList[i].id == this.modalSvc.selectedInvitation) {
          this.rosterMemberService.fetchInvitationMembers(this.id, this.modalSvc.selectedInvitation, this.modalSvc.invitationList[i].members_count)
            .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
              this.filterData = res?.members;
            if (res.members.length == 0) {
              this.filterData = "Member not Found";
            }
            this.loading = false;
          });
          break;
        }
      }
    }
  }

  // add remove member from selected users
  public toggleSelectedUser(user) {
    this.selectionSvc.toggleSelectedUser(user, this as unknown as IRosterSelectionHost);
  }

  // checked or unchecked member for team as well as invitation
  memberChecked(record: any) {
    this.selectionSvc.memberChecked(record, this as unknown as IRosterSelectionHost);
  }

  public secretEmail(usrEmail, length = 8) {
    return usrEmail?.substring(0, length) + "...";
  }

  public selectedGroupProfileTeams(team) {
    this.teamOpsService.selectedGroupProfileTeams(team, this as unknown as IRosterTeamOpsHost);
  }

  updateCurrentPg(pg) {
    this.navSvc.updateCurrentPg(pg, this as unknown as IRosterNavHost);
  }

  updateAcmeRosterTeamMemberFn(data: any) {}
  deleteAcmeRosterTeamMemberFn(data: any) {}
  addAcmeRosterTeamMemberFn(data: any) {}

  rosterMemberProfile(profile) {
    localStorage.setItem('roster_user_profile', JSON.stringify(profile));
  }

  onMemberGoToProfile(member) {
    this.rosterMemberProfile(member.default_profile);
    this.route.navigate(['/orgs', this.id, 'member-profile', member.default_profile.id]);
  }

  public onTeamsPerPageChange(value: number) {
    this.teamsPerPage = value;
    this.updateCurrentPg(1);
  }

  onDirectoryOpenSideBar(team) {
    this.teamID = team?.id;
    this.memberCurrentPg = 1;
    this.gridHirView = 'memView';
    this.memViewTeam = team;
    this.teamSrchName = '';
  }

}
